// This file was automatically generated by staticrc.js.
// Do not edit this file!  Edit the inputs and rebuild instead.

const quadFragBAPass1 = `precision highp float;
varying vec2 texCoord;

uniform sampler2D imageA;
uniform sampler2D imageB;
uniform sampler2D imageMask;

uniform bool swapChannels;
uniform vec3 colorAdjustA;
uniform vec3 colorAdjustB;

uniform mat3 texTransformOut;
uniform mat3 texTransformA;
uniform mat3 texTransformB;

//color adjust
//match HTML5 spec: https://www.w3.org/TR/filter-effects
//in listed order, apply:
//  brightness, v in [-1,1]: c -> c*(1+v)
//  contrast,   v in [ 0,2]: c -> lerp(0.5,c,v)
//  saturate,   v in [ 0,2]: [r,g,b] -> lerp([g,g,g],[r,g,b],v), g = [r,g,b].[0.213,0.715,0.072]
vec3 adjustColor(vec3 color, vec3 adjustments){
  //adjust brightness
  color *= 1.0+adjustments.x;

  //adjust contrast
  vec3 noContrast = vec3(0.5, 0.5, 0.5);
  color = mix(noContrast, color, adjustments.y);

  //adjust saturation
  float lum = dot(color, vec3(0.213, 0.715, 0.072));
  vec3 noSaturation = vec3(lum, lum, lum);
  color = mix(noSaturation, color, adjustments.z);
  
  return color;
}

//use input tex coordinates to determine texture tex coords
vec2 computeTex(mat3 texTransform){
  vec3 texH = texTransform * vec3(texCoord.x, 1.0-texCoord.y, 1.0);
  vec2 texDH = texH.xy / texH.z;
  return vec2(texDH.x, texDH.y);
}

//float value: 0 if p is outside unit square, 1 if inside unit square
float inUnitSquare(vec2 p){
  return step(0.0,p.x) * (1.0-step(1.0,p.x)) * step(0.0,p.y) * (1.0-step(1.0,p.y));
}

void main () {
  vec2 texOut = computeTex(texTransformOut);
  vec2 texA = computeTex(texTransformA);
  vec2 texB = computeTex(texTransformB);

  vec3 colorA = adjustColor(texture2D(imageA, texA).rgb, colorAdjustA);
  vec3 colorB = adjustColor(texture2D(imageB, texB).rgb, colorAdjustB);
  vec3 cMask = texture2D(imageMask, texOut).rgb;

  float coeffA = swapChannels ? cMask.b : cMask.r;
  float coeffB = swapChannels ? cMask.r : cMask.b;
  float coeffMask = clamp(cMask.r + cMask.b, 0.0, 1.0);
  
  vec4 cComposite = vec4( coeffMask*(coeffA*colorA + coeffB*colorB), 1.0 );

  float visibility = inUnitSquare(texOut);
  gl_FragColor = clamp(visibility * cComposite, 0.0, 1.0);
}
`;

const quadFragBAPass2 = `precision highp float;
varying vec2 texCoord;

uniform sampler2D imageL;
uniform sampler2D imageOverlay;

uniform mat3 texTransformL;
uniform mat3 texTransformOut;

//use input tex coordinates to determine texture tex coords
vec2 computeTex(mat3 texTransform){
  vec3 texH = texTransform * vec3(texCoord.x, 1.0-texCoord.y, 1.0);
  vec2 texDH = texH.xy / texH.z;
  return vec2(texDH.x, texDH.y);
}

//float value: 0 if p is outside unit square, 1 if inside unit square
float inUnitSquare(vec2 p){
  return step(0.0,p.x) * (1.0-step(1.0,p.x)) * step(0.0,p.y) * (1.0-step(1.0,p.y));
}

void main () {
  vec2 texOut = computeTex(texTransformOut);
  vec2 texL = computeTex(texTransformL);

  vec4 colorL = texture2D(imageL, texL);
  vec4 colorO = texture2D(imageOverlay, texOut);
  
  colorL.a *= inUnitSquare(texL);
  colorO.a *= inUnitSquare(texOut);

  //blend multiple layers using premultiplied alpha
  vec4 accum = vec4(0.0, 0.0, 0.0, 1.0);
  accum = (1.0-colorO.a)*accum + vec4(colorO.a*colorO.rgb, 0.0);
  accum = (1.0-colorL.a)*accum + vec4(colorL.a*colorL.rgb, 0.0);
  
  gl_FragColor = vec4(accum.rgb, 1.0-accum.a);
}
`;

const quadFragCopy = `precision highp float;

uniform sampler2D texColor;

varying vec2 texCoord;

void main(){
  gl_FragColor = texture2D(texColor, texCoord);
}
`;

const quadVert = `attribute vec3 vertexPos;
attribute vec2 vertexTex;

varying vec2 texCoord;

void main(){
  texCoord = vertexTex;
  gl_Position = vec4(vertexPos, 1.0);
}
`;

export {
  quadFragBAPass1,
  quadFragBAPass2,
  quadFragCopy,
  quadVert,
};
